import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { LoadingState } from "./components/Feedback";
import { RequireAccount } from "./components/RequireAccount";
import { ProductHome, RequireSalesProduct } from './components/RequireSalesProduct';
import { MyAccountPanel } from "./pages/MyAccountPanel";

const LeadsPage = lazy(() => import("./pages/LeadsPage").then((module) => ({ default: module.LeadsPage })));
const NewTaskPage = lazy(() => import("./pages/NewTaskPage").then((module) => ({ default: module.NewTaskPage })));
const SettingsConsole = lazy(() => import("./pages/SettingsConsole").then((module) => ({ default: module.SettingsConsole })));
const WorkbenchPage = lazy(() => import("./pages/WorkbenchPage").then((module) => ({ default: module.WorkbenchPage })));
const PhoneWallPage = lazy(() => import("./pages/PhoneWallPage").then((module) => ({ default: module.PhoneWallPage })));
const CustomerRepliesPage = lazy(() => import("./pages/CustomerRepliesPage").then((module) => ({ default: module.CustomerRepliesPage })));
const TaskSettingsPage = lazy(() => import("./pages/TaskSettingsPage").then((module) => ({ default: module.TaskSettingsPage })));
const QueuePage = lazy(() => import("./pages/QueuePage").then((module) => ({ default: module.QueuePage })));
const LoginPage = lazy(() => import("./pages/LoginPage").then((module) => ({ default: module.LoginPage })));
const FangtangPage = lazy(() => import("./pages/FangtangPage").then((module) => ({ default: module.FangtangPage })));
const InputDiagnosticsPage = lazy(() => import("./pages/InputDiagnosticsPage").then((module) => ({ default: module.InputDiagnosticsPage })));
const BloggerIntelligencePage = lazy(() => import("./pages/BloggerIntelligencePage").then((module) => ({ default: module.BloggerIntelligencePage })));
const LocalDeviceAccessPage = lazy(() => import("./pages/LocalDeviceAccessPage").then((module) => ({ default: module.LocalDeviceAccessPage })));
const VideoWorkshopPage = lazy(() => import("./pages/VideoWorkshopPage").then((module) => ({ default: module.VideoWorkshopPage })));

export default function App() {
  return (
    <Suspense fallback={<LoadingState label="正在加载页面" />}>
      <Routes>
        <Route path="/login" element={<LoginPage key="login" />} />
        <Route path="/password-reset" element={<LoginPage key="password-reset" resetPassword />} />
        <Route path="/local-devices" element={<LocalDeviceAccessPage />} />
        <Route element={<RequireAccount />}>
          <Route element={<RequireSalesProduct />}>
          <Route path="/phone-wall" element={<PhoneWallPage />} />
          <Route path="/input-diagnostics/:deviceId" element={<InputDiagnosticsPage />} />
          </Route>
          <Route element={<AppShell />}>
            <Route path="/account" element={<MyAccountPanel />} />
            <Route path="/video-workshop" element={<VideoWorkshopPage />} />
            <Route index element={<ProductHome />} />
            <Route element={<RequireSalesProduct />}>
            <Route path="/overview" element={<WorkbenchPage />} />
            <Route path="/task-settings" element={<TaskSettingsPage />} />
            <Route path="/fangtang" element={<FangtangPage />} />
            <Route path="/queue" element={<QueuePage />} />
            <Route path="/queue/new" element={<NewTaskPage />} />
            <Route path="/replies" element={<CustomerRepliesPage />} />
            <Route path="/leads" element={<LeadsPage />} />
            <Route path="/blogger-intelligence" element={<BloggerIntelligencePage />} />
            <Route path="/fangtang-data" element={<Navigate to="/blogger-intelligence" replace />} />
            <Route path="/settings" element={<SettingsConsole />} />
            <Route path="*" element={<ProductHome />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </Suspense>
  );
}
